import Blue from "~/core";

new Blue({
	name: 'Table',
	selector: ".table--data",
	setup(table) {
		const thead = table.querySelector('thead')
		const tbody = table.querySelector('tbody');
		const headers = [...thead.querySelectorAll('th')];
		const cells = [...tbody.querySelectorAll('td')];
		const rows = [...tbody.querySelectorAll('tr')];
		const mqTable = window.matchMedia("(max-width: 1200px)");
		const checkboxes = table.querySelectorAll('.table-chk');
		if (table.classList.contains('table--sortable')) {
				//headers sort
				//for the current table, find all rows (except the first)...
				const getCellValue = (tr, idx) => tr.children[idx].innerText || tr.children[idx].textContent;
				//sort the rows, based on the value of the clicked column...
				const comparer = (idx, asc) => (a, b) => ((val1, val2) =>
						val1 !== '' && val2 !== '' && !isNaN(val1) && !isNaN(val2) ? val1 - val2 : val1.toString().localeCompare(val2)
				)(getCellValue(asc ? a : b, idx), getCellValue(asc ? b : a, idx));
				//insert the rows back into the table, in the new order.
				headers.forEach(header => header.addEventListener('click', (() => {
						rows
								.sort(comparer(headers.indexOf(header), header.asc = !header.asc))
								.forEach(tr => tbody.appendChild(tr));
				})));
		}

		//center and cap width for columns that have a heading with the shrinkcol class
		function cellWidth() {
				headers.forEach((header) => {
						if (header.classList.contains('table-shrinkCol')) {
								header.classList.add('test');
								let hIndex = [...header.parentElement.children].indexOf(header)
								let thisCells = cells.filter(cell => {
										let cIndex = [...cell.parentElement.children].indexOf(cell)
										if (hIndex == cIndex) {
												cell.style.textAlign = 'center';
										}
								})
						}
				});
		}
		//toggle text in hidden div for sorting based on checkbox/icon click
		function hiddenText() {
				checkboxes.forEach((checkbox) => {
						const hiddenText = checkbox.closest('td').querySelector('.table-hidden');
						if (checkbox.checked == true) {
								hiddenText.innerHTML = 'Yes';
						} else {
								hiddenText.innerHTML = 'No';
						}
				});
		}

		hiddenText();
		checkboxes.forEach((checkbox) => {
				checkbox.addEventListener('click', () => {
						hiddenText();
				});
		});

		//adjust height of headers and cells in mobile view
		function cellHeight() {
				if (mqTable.matches) {
						// first clear all hieghts
						cells.forEach(cell => cell.style.height = '')
						headers.forEach(header => header.style.height = '')
						//loop through and assign tallest height to all cells
						headers.forEach((header) => {
								let height = header.offsetHeight;
								let hIndex = [...header.parentElement.children].indexOf(header)
								let thisCells = cells.filter(cell => {
										let cIndex = [...cell.parentElement.children].indexOf(cell)
										if (hIndex == cIndex) {
												if (cell.offsetHeight > height) {
														height = cell.offsetHeight
												}
												return true
										}
										return false
								})
								header.style.height = `${height}px`;
								thisCells.forEach(cell => cell.style.height = `${height}px`)
						});
				}
		}
		//clean everything up
		function cleanMobile() {
				cells.forEach(cell => cell.style.height = '')
				headers.forEach(header => header.style.height = '')
		}

		function cleanDesktop() {
				cells.forEach(cell => cell.style.textAlign = '')
		}

		function screenSize(mqTable) {
				if (mqTable.matches) {
						cleanDesktop();
						cellHeight();
						window.addEventListener('resize', cellHeight);
				} else {
						cleanMobile();
						cellWidth();
				}
		}
		// Handle media query 'change' event
		mqTable.addListener(screenSize);
		screenSize(mqTable);
	}
});